import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import "./HaveAProject.css";
import RichTextContent, { CmsText } from "../../../RichTextContent/RichTextContent";
import { useInsightsSection } from "../../../../context/InsightsPageContext";
import { useCmsPageSection } from "../../../../hooks/useCmsPageSection";
import { resolveMediaUrl } from "../../../../utils/resolveMediaUrl";

const HaveAProject = () => {
  const insights = useInsightsSection("have-a-project");
  const fetched = useCmsPageSection("insights", "have-a-project", {
    skip: insights.fromInsightsPage,
  });

  const section = insights.fromInsightsPage
    ? insights.section
    : fetched.section;
  const loading = insights.fromInsightsPage
    ? insights.loading
    : fetched.loading;

  const bgSrc = useMemo(() => {
    const url = section?.media?.primary?.url;
    return url ? resolveMediaUrl(url) : "";
  }, [section]);

  if (loading || !section?.fields) return null;

  const fields = section.fields;

  return (
    <section className="projectcta">
      <div className="projectcta-card">
        {bgSrc ? <img src={bgSrc} alt="" className="projectcta-bg" /> : null}

        {fields.title ? (
          <CmsText content={fields.title} as="h2" />
        ) : null}

        {fields.description ? (
          <RichTextContent content={fields.description} />
        ) : null}

        {fields.buttonLink ? (
          <Link to={fields.buttonLink} className="buttonclip projectcta-btn">
            <CmsText content={fields.buttonText} as="span" />
          </Link>
        ) : null}
      </div>
    </section>
  );
};

export default HaveAProject;
